module.exports = {
	"header": "Facture",
	"create": "Créer une facture",
	"created": "Facture créée!",
	"entryDescriptions": {
		"subscriptionRenewal": "Renouvellement d'abonnement"
	},
	"entryTypes": {
		"subscription": "Abonnement"
	},
	"invoiceParams": "Paramètres de la facture",
	"numberOfInvoices": "Nombre de factures",
	"noInvoice": "Aucune facture.",
	"statuses": {
		"0": "Brouillon",
		"1": "À payer",
		"2": "En retard",
		"3": "Annulée",
		"4": "Payée"
	},
	"types": {
		"draft": "Factures en préparation",
		"due": "Factures dues",
		"paid": "Factures payées",
		"cancelled": "Factures annulées"
	},
	"errors": {
		"oneItemMinimum": "Vous devez avoir au moins un item sur votre facture."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/invoice.json5
// module id = 1988
// module chunks = 6